export default __webpack_public_path__ + "static/media/ic_ios.faf72cf5.svg";